export const ROUTES = {
    LOGIN: '/login',
    HOMEPAGE: '/',
    NOTIFICATIONS: '/notifications',
    USERMANAGEMENT: '/usermanagement'
}